"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
const COOKIE_EXPIRY_1 = __importDefault(require("../../../constants/app/COOKIE_EXPIRY"));
const STORAGE_KEYS_1 = __importDefault(require("../../../constants/app/STORAGE_KEYS"));
/**
 * Sets the user session in a session cookie
 * @param {string} sessionToken
 */
function setSessionCookie(sessionToken) {
    js_cookie_1.default.set(STORAGE_KEYS_1.default.AUTH_COOKIE, sessionToken, {
        expires: COOKIE_EXPIRY_1.default,
        secure: true,
        // sameSite: 'strict' // iOS Safari has issues - https://stackoverflow.com/questions/58525719/safari-not-sending-cookie-even-after-setting-samesite-none-secure
    });
}
exports.default = setSessionCookie;
